import { getFallbackValueIfNull } from 'owa-options-core';
import store from '../data/store/store';
import { getCalendarConfiguration } from 'owa-calendar-configuration';
/**
 * Gets the fallback value for first week of the year
 */
export default (function () {
    return getFallbackValueIfNull(store().firstWeekOfYear, getCalendarConfiguration().FirstWeekOfYear);
});
export { FirstWeekRules };
//# sourceMappingURL=getFirstWeekOfYear.js.map